module.exports = __webpack_public_path__ + "static/media/woman-in-flower-garden.400d0c45.jpg";